import { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { TextField } from '@mui/material';
import PasswordInput from '../common/PasswordInput';
import { useDispatch, useSelector } from 'react-redux';
import { selectSignInloading } from '../../redux-state/selectors';
import CircularIndeterminate from '../common/Progress';
import PrimaryButton from "../common/button/PrimaryButton";

const LoginForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState('');

  const signInloading = useSelector(selectSignInloading);

  const backendError = useSelector((state) => state.userAuth.error);
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEmailError('');

    if (!emailPattern.test(email)) {
      setEmailError('Invalid email format');
      return;
    }

    login();
  };

  const login = () => {
    dispatch({
      type: 'SIGN_IN',
      payload: {email: email, password: password},
      navigate,
    });
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    dispatch({ type: 'CLEAR_MFA_ERROR' });
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    dispatch({ type: 'CLEAR_MFA_ERROR' });
  };

  const navigateToForgotPassword = () => {
    dispatch({ type: 'CLEAR_MFA_ERROR' });
    navigate("/forgotPassword")
  }

  return (
    <>
      <div className="h-[100%] flex items-center">
        <form className="px-8" onSubmit={handleSubmit}>
          <div className='mb-16'>
            <div className="text-3xl font-bold mb-4">
              Welcome back to your Account
            </div>
            <div>
              Please login to access DMV Navigator
            </div>
          </div>

          <div className="mb-4">
            <TextField
              required
              className="w-full"
              value={email}
              onChange={handleEmailChange}
              id="outlined-required"
              label="Email"
              error={!!emailError}
              helperText={emailError}
              InputProps={{ className: 'boarder-radius-10' }}
            />
          </div>

          <div className="mb-4">
            <PasswordInput
              className="w-full"
              password={password}
              handlePassword={handlePasswordChange}
            />
          </div>

          <div className="text-red-500 text-end mb-8">
            <button onClick={navigateToForgotPassword}>Forgot password</button>
          </div>

          <PrimaryButton
            id="login-button"
            text="LogIn"
            type="submit"
            className="w-full"
            disabled={signInloading}
          />

          {backendError && (
            <p className="text-red-500 text-sm mt-2">{backendError}</p>
          )}

          <div className="text-center text-gray-500 text-xs mt-6">
            Don't have an account?{' '}
            <Link to="/signup" className="font-bold">SignUp</Link>
          </div>
        </form>
      </div>

      <div className="justify-self-end flex flex-row w-full justify-between bottom-20 p-8">
        <div></div>
        <div>Copyright 2026</div>
      </div>

      {signInloading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <CircularIndeterminate />
        </div>
      )}
    </>
  );
};

export default LoginForm;
